export default __webpack_public_path__ + "static/logo-armanihotels-e158f4b11959762916c2b3308ad40a6e.svg";